export default {
  home: 'Home',
  domestic: 'China Fair',
  international: 'International Fair',
  exhibitionInfo: 'News',
  conventionCenter: 'Center',
  cooperate: 'Cooperate',
  visa: 'Visa',
  keywordPlaceholder1: 'Please enter a keyword',
  keywordPlaceholder2: 'Search term length exceeds 50 word limit, please delete and try again',
  keywordPlaceholder3: 'Please enter Chinese characters or letters',
  keyword_error1: 'Only Chinese characters or letters can be searched',
  keyword_error2: 'Search term length exceeds 50 word limit, please delete and try again',
  top: {
    ticket: 'My ticket',
    fair: 'My exhibition',
    industry: 'My industry',
    leaderboard: 'Leaderboard',
    sitemap: 'sitemap',
    signup: 'Login/Registration',
    order: 'My order',
    quit: 'logout'
  }
}
